module.exports = __webpack_public_path__ + "static/img/wisa.65db9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wisa.png
// module id = 9CXu
// module chunks = 1